import { cache } from '@dimjs/utils';

const zIndexFactory = cache('zIndex', 100);

export const getZIndex = () => {
  return Number(zIndexFactory().replace('zIndex', ''));
};
